module.exports = __webpack_public_path__ + "img/Night at the Museum 3.82eaaa35.jpeg";